/* WASTELAND TCG — core rules layer (Phase 1 of the keyword system).
   Seven shared keywords give every faction a distinct verb; each card's printed
   rules ride on top. CARD_RULES is generated from the catalog (faction identity +
   printed text) — regenerate via /tmp/gen_tcg_rules.js when new cards land.
   Phase 2 wires these into the turn-based Rules Match engine. */

export const KEYWORD_GLOSSARY = [
  { id: "salvage", name: "Salvage X", text: "When this card dies, gain X scrap or draw from your crate." },
  { id: "guard", name: "Guard", text: "Enemies must target this card in combat before any other unit in your lane." },
  { id: "overclock", name: "Overclock", text: "This unit's ability triggers only if you've spent no scrap this turn — the reward for banking resources." },
  { id: "bounty", name: "Bounty", text: "When this unit destroys an enemy, gain PTS/scrap equal to the stated value." },
  { id: "signal", name: "Signal X", text: "This card gets +X to a stat if you control 2+ other cards from the same faction — soft synergy, no hard lock." },
  { id: "corrupted", name: "Corrupted X", text: "This unit deals X damage to itself or to you each round it's in play — raw power always costs something." },
  { id: "jam", name: "Jam", text: "Instant-speed trick: disables an enemy's ability or ability trigger for one round." },
];

export const FACTION_IDENTITIES = [
  { faction: "SCRAPPER", verb: "RECURSION", text: "Rebels of the scrap economy — cheap units with Salvage turn dead cards and spent scrap back into value." },
  { faction: "BLACK-OPS NET", verb: "CONTROL", text: "The council's hidden hand — stealth, removal, and most of the game's Jam effects. The information faction." },
  { faction: "MUTANT", verb: "RISK", text: "Huge ATK lines gated behind Corrupted or coin-flips — unstable power, never free." },
  { faction: "BOUNTY GUILD", verb: "TEMPO", text: "Hunters built around Bounty — aggressive units that snowball scrap and PTS with every kill." },
  { faction: "WASTELAND VANGUARD", verb: "DEFENSE", text: "Board control through Guard — walls, bastions and haulers that force the fight to come to them." },
  { faction: "AL RIOTBALL", verb: "CHAOS", text: "Cheap, swingy, coin-flip tempo — the wildcard combat-trick faction, never a stat-stick faction." },
  { faction: "BOSS", verb: "PvE ONLY", text: "Weekly-boss tier — hunt them in the Arena rotation. Not legal in pack decks, never in crates." },
];

export const CARD_TYPES = ["UNIT", "TERRAIN", "TACTIC", "GEAR"];

const CARD_RULES = {
  "kaelen": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "zion": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "orion": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "drion": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "valkyrie": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "net-commander": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "net-warden": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "phantom": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "infantry": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "dolt": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "kushiro": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "scavenger": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "vanguard": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "echo": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "volo": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "singularity": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "omnicron": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "cyber-tyrant": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "architect": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "cyber-queen": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "abyss": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "cyber-ape": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "omnicron-nexus": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "singularity-zero-point": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "nexus-omnicron": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "circe": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "dolo": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "deacon": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "funk-master": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "goji": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "dark-dolo": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "kai": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "jonah": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "sarah": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "kishuu": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "kenjiro": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "gorge-claw": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "sinew-walker": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "ash-skin": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "energy-eater": {
    "type": "UNIT",
    "keywords": [
      "Jam"
    ]
  },
  "sand-worm": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "luna": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "malfunction-7": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "vex": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "osteowarrior": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "metal-witch": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "cyborg-shogun": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "riff": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "koji": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "sniper-elite": {
    "type": "UNIT",
    "keywords": [
      "Bounty 3"
    ]
  },
  "core-runner": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "heavy-enforcer": {
    "type": "UNIT",
    "keywords": [
      "Bounty 3"
    ]
  },
  "goliath": {
    "type": "UNIT",
    "keywords": [
      "Bounty 3"
    ]
  },
  "elara": {
    "type": "UNIT",
    "keywords": [
      "Bounty 4"
    ]
  },
  "white-guard-bastion": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "command-bastion": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "sector-9-point": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "sector-defense-bastion": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "goliath-hauler": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "mutated-brute": {
    "type": "UNIT",
    "keywords": [
      "Bounty 2"
    ]
  },
  "siege-mutant": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "chronos-chimera": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "assimilation-abomination": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "riotball-final": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "white-guard-reinforcement": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "red-force-pitch": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "overcharged-core": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "scrapper-elite-technician": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "sector-9-lockdown": {
    "type": "TERRAIN",
    "keywords": []
  },
  "ironclad": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "scavenger-elite": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "field-commander": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "city-runner": {
    "type": "UNIT",
    "keywords": [
      "Salvage 1"
    ]
  },
  "assimilation-lord": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "data-vanguard": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "vanguard-scrapper-elite": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "data-elite": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "bio-assimilator": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "omega-7": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "eye-clusters": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "eye-clusters-ocular": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 1"
    ]
  },
  "eye-clusters-psionic": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "spine-chimera": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "rust-eater": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "spine-chimera-assault": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "shadow-kind": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "scale-hide": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "mutted-chatterer": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 1"
    ]
  },
  "blight-bringer": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "mutted-chatterer-internal": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "mutted-chatterer-cortex": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 2"
    ]
  },
  "kane-ironhide": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "chimera-lord-vance": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3"
    ]
  },
  "eliza-patch": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "maeve-glitch": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "jax-surge": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "kara-raven": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "zoe-spark": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "elias-scrap": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "kenji-shift": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "eliza-maw": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "caleb-forge": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "lyra-shadow": {
    "type": "UNIT",
    "keywords": [
      "Salvage 2"
    ]
  },
  "super-ronin-dolo": {
    "type": "UNIT",
    "keywords": []
  },
  "vinyl-valkyrie": {
    "type": "UNIT",
    "keywords": []
  },
  "tape-worm": {
    "type": "UNIT",
    "keywords": []
  },
  "last-hero": {
    "type": "UNIT",
    "keywords": []
  },
  "synth-ronin": {
    "type": "UNIT",
    "keywords": []
  },
  "cybernetic-revival-chamber": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-repair-bay": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-archive-vault": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-arsenal-forge": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-refinery-complex": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "kai-vagabond": {
    "type": "UNIT",
    "keywords": [
      "Guard"
    ]
  },
  "elara-scout": {
    "type": "UNIT",
    "keywords": [
      "Signal 1"
    ]
  },
  "rez-waste-bearer": {
    "type": "UNIT",
    "keywords": [
      "Corrupted 3",
      "Overclock"
    ]
  },
  "sector-9-lockdown-perimeter": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "sector-9-chaos-engine": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-data-spy-network": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock",
      "Jam"
    ]
  },
  "omega-protocol": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "scavengers-guild": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "technomancers-cabal": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "nexus-convergence": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "nexus-prime-core": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cybernetic-veterans-legion": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "chronos-vortex": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "synthetic-ascension-core": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "cyber-psionic-matrix": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "omega-project": {
    "type": "TERRAIN",
    "keywords": [
      "Overclock"
    ]
  },
  "chrono-steward-aethel": {
    "type": "UNIT",
    "keywords": [
      "Overclock"
    ]
  },
  "chrono-keeper-elara": {
    "type": "UNIT",
    "keywords": [
      "Overclock"
    ]
  },
  "chrono-architect-kaelen": {
    "type": "UNIT",
    "keywords": [
      "Overclock"
    ]
  },
  "chrono-lord-kaeleb": {
    "type": "UNIT",
    "keywords": [
      "Overclock"
    ]
  }
};

// rules for any card — generated tags first, faction identity as the fallback
// so cards added between print runs still read correctly on the table
export const getCardRules = (card) => {
  const hit = CARD_RULES[card.id];
  if (hit) return hit;
  return { type: /^(TERRAIN|ARENA)/.test(card.role || "") ? "TERRAIN" : "UNIT", keywords: [] };
};

export const isPveOnly = (card) => card.faction === "BOSS";
